import React, {Fragment} from 'react';
import {connect} from "react-redux";
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import WizardGroupsAsideGroup from "./WizardGroupsAsideGroup";
import WizardGroupsAsideList from "./WizardGroupsAsideList";
import {setWizardDraggingGroupIndex} from "../wizardFlowActions";
import {WIZARD_GROUP_TYPES} from "../WizardItem/wizardItemInterface";
import {AVAILABLE_VISUALIZERS} from "../../../constants/dashboard";

const getIndexByNodeType = (nodeType) => {
  switch (nodeType) {
    case WIZARD_GROUP_TYPES.custom:
      return -6
    case WIZARD_GROUP_TYPES.inputs:
      return -5
    case WIZARD_GROUP_TYPES.contact:
      return -4
    case WIZARD_GROUP_TYPES.appointment:
      return -3
    case WIZARD_GROUP_TYPES.review:
      return -2
    case WIZARD_GROUP_TYPES.success:
      return -1
    default:
      return 0
  }
}

const customButtons = Object.values(WIZARD_GROUP_TYPES).filter(nodeType => {
  return nodeType !== WIZARD_GROUP_TYPES.group && nodeType !== WIZARD_GROUP_TYPES.filter
})

const SortableCustomItem = SortableElement(({ wizardActiveItem, featureGroup, key, nodeType }) => {
  return <WizardGroupsAsideGroup wizardActiveItem={wizardActiveItem}
                                 groupIndex={getIndexByNodeType(nodeType)}
                                 nodeType={nodeType}
                                 featureGroup={featureGroup}
                                 key={key}/>
});

const SortableList = SortableContainer((props) => {
  const {wizardFlowActiveMode, wizardActiveItem, intl, searchText, notReceivedWizardGroupFilters, wizardVisualizer} = props;


  return (
    <div className="wizard-sidebar__content">
      {customButtons.map(nodeType => {
        if (wizardVisualizer !== AVAILABLE_VISUALIZERS.leadform && (nodeType !== WIZARD_GROUP_TYPES.custom)) {
          return null
        }
        return (
          <SortableCustomItem wizardActiveItem={wizardActiveItem}
                              key={nodeType}
                              index={getIndexByNodeType(nodeType, wizardVisualizer)}
                              featureGroup={{groupName: intl.formatMessage({id: "wizard.group.type." + nodeType})}}
                              nodeType={nodeType}/>
        )
      })}
      {wizardFlowActiveMode === WIZARD_GROUP_TYPES.filter && (wizardActiveItem.wizardNodes.filter(node => node.selected).length === 1) ? (
        <Fragment>
          <h3 className="ui-input3-title"><FormattedMessage id="wizard.groups.aside.currentFilters"/></h3>
          <ul className="wizard-sidebar__list fix-ul">
            <WizardGroupsAsideList wizardActiveItem={wizardActiveItem}
                                   searchText={searchText}
                                   notReceivedWizardGroupFilters={notReceivedWizardGroupFilters}/>
          </ul>
          <h3 className="ui-input3-title"><FormattedMessage id="wizard.groups.aside.allOther"/></h3>
        </Fragment>
      ) : null}
      <ul className="wizard-sidebar__list fix-ul">
        <WizardGroupsAsideList wizardActiveItem={wizardActiveItem}
                               searchText={searchText}
                               notReceivedWizardGroupFilters={notReceivedWizardGroupFilters}/>
      </ul>
    </div>
  );
});

const WizardGroupsAsideSortableItems = (props) => {

  const {wizardActiveItem, notReceivedWizardGroupFilters, searchText, intl, setWizardDraggingGroupIndex,
    wizardFlowActiveMode, wizardVisualizer} = props;

  const onSortEnd = () => {
    document.body.style.cursor = "";
    setWizardDraggingGroupIndex(null);
    // if (oldIndex !== newIndex) {
    //   wizardActiveItem.wizardGroups = arrayMove(wizardActiveItem.wizardGroups, oldIndex, newIndex);
    //   wizardActiveItem.wizardGroups.forEach((wizardGroup, wizardGroupIndex) => {
    //     wizardGroup.order = wizardGroupIndex;
    //   });
    //   updateWizardList(wizardActiveItem);
    // }
  }

  const onSortStart = (event) => {
    document.body.style.cursor = "grabbing";
    setWizardDraggingGroupIndex(event.index);
  }

  const shouldCancelStart = () => {
    // return !(event.target.classList.contains("wizard-item__dots") || event.target.closest(".wizard-item__dots"))
  }

  return (
    <SortableList wizardActiveItem={wizardActiveItem}
                  helperClass='sortableHelper'
                  axis={"xy"}
                  wizardFlowActiveMode={wizardFlowActiveMode}
                  wizardVisualizer={wizardVisualizer}
                  notReceivedWizardGroupFilters={notReceivedWizardGroupFilters}
                  searchText={searchText}
                  intl={intl}
                  // pressDelay={100}
                  shouldCancelStart={shouldCancelStart}
                  onSortStart={onSortStart}
                  onSortEnd={onSortEnd} />
  )
};``

WizardGroupsAsideSortableItems.propTypes = {
  wizardActiveItem: PropTypes.object.isRequired
}

const mapStateToProps = (store) => {
  const {wizardFlowActiveMode, wizardVisualizer} = store.wizardState;
  return {
    wizardFlowActiveMode,
    wizardVisualizer,
  };
};

const mapDispatchToProps = {
  setWizardDraggingGroupIndex
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(WizardGroupsAsideSortableItems))
